import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockServiceAdditional {
	static init() {
		this.blocks = document.querySelectorAll(".block-service-additional");

		this.blocks.forEach(block => {

			let services = block.querySelectorAll(".service");
			services.forEach(service => {
				const image = service.querySelector(".image-container");

				ScrollTrigger.matchMedia({
					"(min-width: 768px)": () => {
						gsap.to(image, {
							ease: "power1.inOut",
							width: "100%",
							height: "30vw",
							scrollTrigger: {
								trigger: service,
								start: 'top 45%',
								end: 'top -10%',
								scrub: true
							}
						});
					}
				});
			});
		});
	}
}
